import React, { PropTypes } from 'react';
import { Link } from 'react-router';
import classnames from 'classnames';
import ReviewsAgg from 'marketing/containers/reviews_agg';

const Testimonials2 = ({ title, subtitle, testimonials, background, cta }) => (
  <section className={classnames("block block-testimonials-2", background)}>
    <div className="row columns">
      { subtitle?
      <div className="block-header">
        <h2>{ title }</h2>
        <h3>{ subtitle }</h3>
      </div> :
      <div className="block-header">
        <ReviewsAgg title={<h2>{ title }</h2>} />
      </div> }
    </div>
    <div className="row">
      { testimonials.map((testimonial, i) => (
      <div className="small-16 medium-8 columns" key={i}>
        <div className="testimonial">
          <h3 className="quote">&quot;{ testimonial.quote }&quot;</h3>
          { !!testimonial.image &&
          <img alt={testimonial.headline} src={testimonial.image} className="avatar avatar-round" /> }
          <div className="testimonial-meta">
            <h4>{ testimonial.name }</h4>
            { (!!testimonial.title || !!testimonial.company) &&
            <div className="extra">
              { testimonial.title }
              { !!testimonial.title && !!testimonial.company && ', ' }
              { testimonial.company }
            </div> }
          </div>
        </div>
      </div> )) }
    </div>
    { !!cta &&
    <div className="text-center cta">
      <Link to={cta.link} target="_blank">{ cta.label }</Link>
    </div> }
  </section>
);

Testimonials2.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  testimonials: PropTypes.array.isRequired,
  background: PropTypes.string,
  cta: PropTypes.object,
};

export default Testimonials2;
